export namespace DrawerState {
  export interface IState {
    open?: boolean;
  }

  export const initialState: IState = {
    open: false,
  };
}
